import { useMemo } from 'react';
import { useField } from 'react-final-form';
import clsx from 'clsx';
import { v4 as uuidv4 } from 'uuid';
import { combineValidators, isEmpty } from './validation';
import { assert } from '../../utils';
import { encodeFieldName } from '../Form';
import useRegisterField from './useRegisterField';
export default function useMergedInputProps({ name, disabled, validate, required, emptyMessage, id, description, inputProps, fieldProps, type, value, isDummy, isEqual, label, hideCharacterCount, censored, }) {
    assert(emptyMessage || !required, `Field "${name}" is required, but no emptyMessage is set!`);
    assert(typeof validate === 'function', `Field "${name}" has a bad "validate" prop - it must be a function, not ${typeof validate}!`);
    // to avoid a limitation of final-form we have to wrap
    // field names. See transformFieldNames.js for details
    const encodedName = encodeFieldName(name, isDummy);
    const combinedValidator = useMemo(() => {
        const requiredValidator = (valueToValidate) => isEmpty(valueToValidate) && emptyMessage;
        return required ? combineValidators(requiredValidator, validate) : combineValidators(validate);
    }, [required, emptyMessage, validate]);
    const { input, meta } = useField(encodedName, Object.assign(Object.assign({}, fieldProps), { validate: combinedValidator, value,
        type,
        isEqual }));
    const { isFormDisabled, showAllErrors } = useRegisterField(label, encodedName);
    const idBase = useMemo(() => (id ? `${id}-field-input` : uuidv4()), [id]);
    const errorId = `error_${idBase}`;
    const fieldError = showAllErrors ? meta.error : meta.touched ? meta.error : '';
    const result = Object.assign(Object.assign(Object.assign(Object.assign({}, input), { className: clsx('kal-field', (description || fieldError) && 'with-description-or-error'), id: idBase, errorId, error: fieldError, 'aria-invalid': Boolean(fieldError) }), inputProps), { 'aria-required': required, 'aria-hidden': Boolean(censored), disabled: Boolean(disabled || isFormDisabled || meta.submitting || censored), hideCharacterCount });
    if (fieldError) {
        result['aria-describedby'] =
            inputProps && inputProps['aria-describedby'] ? `${inputProps['aria-describedby']} ${errorId}` : errorId;
    }
    return result;
}
//# sourceMappingURL=useMergedInputProps.js.map